import i18n from '@/shared/i18n/i18n';

/**
 * Carga dinámicamente las traducciones para una vista (namespace) y las fusiona.
 *
 * @param namespace - El nombre del archivo de traducción (sin extensión) que se desea cargar (por ejemplo, 'login' o 'dashboard')
 */
export async function loadLocaleMessages(namespace: string): Promise<void> {
  const locale = i18n.global.locale.value as string;

  const currentMessages: any = i18n.global.getLocaleMessage(locale);
  if (currentMessages && currentMessages[namespace]) {
    return;
  }

  try {
    const response = await fetch(`/locale/${locale}/${namespace}.json`);
    if (!response.ok) throw new Error(`Could not find locale "${namespace}"`);

    const messages = await response.json();
    i18n.global.mergeLocaleMessage(locale, { [namespace]: messages });
  } catch (error) {
    console.error(`Error al cargar las traducciones para ${namespace}:`, error);
  }
}
